import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/** Fewest and most digits a phone number has; 15 is the international maximum. */
const MIN_PHONE_DIGITS = 7;
const MAX_PHONE_DIGITS = 15;

/** What the field says when the phone does not read as one. */
export const PHONE_FORMAT_MESSAGE = 'Enter a phone number, e.g. +91 98765 43210';

/**
 * Whether `value` reads as a phone number: an optional leading "+" and country
 * code, then digits, with spaces, dashes, dots or brackets between them. Empty
 * counts: whether a phone is required is the field's own rule. The same rule
 * as the server's.
 */
export function isPhoneNumber(value: unknown): boolean {
  if (value === undefined || value === null || value === '') {
    return true;
  }
  if (typeof value !== 'string') {
    return false;
  }
  const text = value.trim();
  const digits = text.replace(/\D/g, '').length;
  return /^\+?[\d\s().-]+$/.test(text) && digits >= MIN_PHONE_DIGITS && digits <= MAX_PHONE_DIGITS;
}

/** A form validator for {@link isPhoneNumber}; the error is `phone`. */
export const phoneNumberValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null =>
  isPhoneNumber(control.value) ? null : { phone: true };
